import React from 'react';

export const InlineCode: React.FC = (props) => (
  <code
    {...props}
    className="bg-accent-light text-main-darkest px-1 rounded whitespace-pre-wrap sm:whitespace-pre"
  />
);
